import React, { useEffect } from 'react';

import { useAppDispatch, useAppSelector } from 'src/store';
import { PATH } from 'src/constants/app';
import { NavigateLink, NoteForm, NoteList } from 'src/components/coreUI/index';
import useClassTopicContent from 'src/hooks/useClassTopicContent';
import { fetchNotes } from 'src/thunks/note';

const Notes: React.FC = () => {
  const { content, class_id, class_topic_content_id } = useClassTopicContent();
  const dispatch = useAppDispatch();
  const user_id = useAppSelector((state) => state.ui.app.me?.id);

  useEffect(() => {
    const promise = dispatch(
      fetchNotes({
        user_id,
        class_id,
        class_topic_content_id: content.id,
        order_by: 'created_at,desc',
      }),
    );

    return () => {
      promise.abort();
    };
  }, [class_id, class_topic_content_id]);

  return (
    <div>
      <NavigateLink
        to={`/${PATH.CLASS}/${class_id}/notes`}
        content={'View All Notes'}
      />
      <div className="mb-24" />

      <NoteList />
      <NoteForm content={content} class_id={class_id} />
    </div>
  );
};

export default Notes;
